import { render } from "./steps-carousel.vue?vue&type=template&id=651de8f3&scoped=true"
import script from "./steps-carousel.vue?vue&type=script&lang=js"
export * from "./steps-carousel.vue?vue&type=script&lang=js"

import "./steps-carousel.vue?vue&type=style&index=0&id=651de8f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651de8f3"]])

export default __exports__